import React from "react";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		root: {
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "space-between",
		},
		first: {
			width: "260px",
		},
		second: {
			width: "305px",
		},
		third: {
			width: "305px",
		},
		fourth: {
			width: "280px",
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			first: {
				width: "210px",
			},
			second: {
				width: "240px",
			},
			third: {
				width: "240px",
			},
			fourth: {
				width: "225px",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				flexWrap: "wrap",
				width: "590px",
				margin: "0 auto",
			},
			first: {
				width: "290px",
				marginBottom: "10px",
			},
			second: {
				width: "290px",
				marginBottom: "10px",
			},
			third: {
				width: "290px",
			},
			fourth: {
				width: "290px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				flexWrap: "wrap",
				width: "100%",
			},
			first: {
				width: "100%",
				marginBottom: "10px",
			},
			second: {
				width: "100%",
				marginBottom: "10px",
			},
			third: {
				width: "100%",
				marginBottom: "10px",
			},
			fourth: {
				width: "100%",
			},
		},
	};
};

class FormLayout extends React.PureComponent {
	render() {
		let classes = this.props.classes;
		let children = this.props.children;
		if (!Array.isArray(children)) {
			return null;
		}

		return (
			<div className={classes.root}>
				<div className={classes.first}>{children[0]}</div>
				<div className={classes.second}>{children[1]}</div>
				<div className={classes.third}>{children[2]}</div>
				<div className={classes.fourth}>{children[3]}</div>
			</div>
		);
	}
}

export default withStyles(styles)(FormLayout);
